import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { forEach } from '@angular/router/src/utils/collection';
declare var require: any;
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'lib-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css'],
})
export class DepartmentComponent implements OnInit {

  @Input() code: string = null
  @Input() codes = []
  @Input() municipalitySelectedMap: any;

  @Output() municipalityCode = new EventEmitter

  constructor(
  ) { }

  ngOnInit(): void {
    let me = this
    let $description = $(".description");


    document.querySelectorAll('.cls-1').forEach(item => {
      item.addEventListener('click', (event: any) => {
        //handle click
        document.querySelectorAll('.cls-1').forEach(item => {
          item.classList.remove("active")
        })
        event.target.classList.add("active")
        // emit the event
        me.municipalityCode.emit(event.target.id)
      })

    })

    $(document).on('mousemove', function (e) {
      // console.log(e)
      $description.css({
        left: e.clientX,
        top: e.clientY - 70
      });

    });


    this.handleSelectEvent(this.municipalitySelectedMap);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.municipalitySelectedMap) {
      this.handleSelectEvent(changes.municipalitySelectedMap.currentValue);

    }

    for (let i = 0; i < this.codes.length; i++) {

      if (this.codes[i].code.length == 4) {

        let element = document.getElementById('_0' + this.codes[i].code)
        if (element) {
          element.classList.add("selected")
        }

      } else {
        let element = document.getElementById('_' + this.codes[i].code)
        if (element) {
          element.classList.add("selected")
        }
      }
    }

  }

  handleCLick(e) {
    if (e.target !== e.currentTarget) {
      var clickedItem = e.target.dataset.name;
      document.querySelectorAll('.cls-1').forEach(item => {
        item.classList.remove("active")
      })
      e.target.classList.add("active")
      // emit the event
      this.municipalityCode.emit(clickedItem)
    }
    e.stopPropagation();
  }


  handleSelectEvent(id) {

    setTimeout(function () {
      document.querySelectorAll('.cls-1').forEach(item => {
        item.classList.remove("active")
      })

      $('#_' + id).addClass("active");
    }, 1500);

  }





  departments = [{
    "id": "91",
    "name": "Amazonas",
    "habitanRate": 78830,
    "latitude": 1.442912,
    "longitude": -71.572395,
    "provinceVictim": null
  }, {
    "id": "05",
    "name": "Antioquia",
    "habitanRate": 6690977,
    "latitude": 6.449486,
    "longitude": -75.488922,
    "provinceVictim": null
  }, {
    "id": "81",
    "name": "Arauca",
    "habitanRate": 270708,
    "latitude": 6.547306,
    "longitude": -71.002231,
    "provinceVictim": null
  }, {
    "id": "88",
    "name": "Archipiélago de San Andrés",
    "habitanRate": 78413,
    "latitude": 12.556732,
    "longitude": -81.718525,
    "provinceVictim": null
  }, {
    "id": "08",
    "name": "Atlántico",
    "habitanRate": 2546138,
    "latitude": 10.6966159,
    "longitude": -74.8741045,
    "provinceVictim": null
  }, {
    "id": "11",
    "name": "Bogotá, D.C.\r\n",
    "habitanRate": 8181047,
    "latitude": 4.710989,
    "longitude": -74.072092,
    "provinceVictim": null
  }, {
    "id": "13",
    "name": "Bolívar",
    "habitanRate": 2171558,
    "latitude": 37.623889,
    "longitude": -93.421674,
    "provinceVictim": null
  }, {
    "id": "15",
    "name": "Boyacá",
    "habitanRate": 1281979,
    "latitude": 5.454511,
    "longitude": -73.362003,
    "provinceVictim": null
  }, {
    "id": "17",
    "name": "Caldas",
    "habitanRate": 993870,
    "latitude": 5.29826,
    "longitude": -75.247906,
    "provinceVictim": null
  }, {
    "id": "18",
    "name": "Caquetá",
    "habitanRate": 496262,
    "latitude": 0.869892,
    "longitude": -73.841906,
    "provinceVictim": null
  }, {
    "id": "85",
    "name": "Casanare",
    "habitanRate": 375258,
    "latitude": 5.758927,
    "longitude": -71.572395,
    "provinceVictim": null
  }, {
    "id": "19",
    "name": "Cauca",
    "habitanRate": 1416145,
    "latitude": 2.704981,
    "longitude": -76.825965,
    "provinceVictim": null
  }, {
    "id": "20",
    "name": "Cesar",
    "habitanRate": 1065637,
    "latitude": 9.337295,
    "longitude": -73.653621,
    "provinceVictim": null
  }, {
    "id": "27",
    "name": "Chocó",
    "habitanRate": 515166,
    "latitude": 5.252803,
    "longitude": -76.825965,
    "provinceVictim": null
  }, {
    "id": "23",
    "name": "Córdoba ",
    "habitanRate": 1788648,
    "latitude": 8.049293,
    "longitude": -75.57405,
    "provinceVictim": null
  }, {
    "id": "25",
    "name": "Cundinamarca",
    "habitanRate": 2804238,
    "latitude": 5.026003,
    "longitude": -74.030012,
    "provinceVictim": null
  }, {
    "id": "94",
    "name": "Guainía\r\n",
    "habitanRate": 43446,
    "latitude": 2.585393,
    "longitude": -68.524715,
    "provinceVictim": null
  }, {
    "id": "95",
    "name": "Guaviare\r\n",
    "habitanRate": 115829,
    "latitude": 2.043924,
    "longitude": -72.331113,
    "provinceVictim": null
  }, {
    "id": "41",
    "name": "Huila",
    "habitanRate": 1197049,
    "latitude": 2.535935,
    "longitude": -75.52767,
    "provinceVictim": null
  }, {
    "id": "44",
    "name": "La Guajira\r\n",
    "habitanRate": 1040193,
    "latitude": 11.354774,
    "longitude": -72.520483,
    "provinceVictim": null
  }, {
    "id": "47",
    "name": "Magdalena\r\n",
    "habitanRate": 1298562,
    "latitude": 10.411301,
    "longitude": -74.405661,
    "provinceVictim": null
  }, {
    "id": "50",
    "name": "Meta",
    "habitanRate": 1016672,
    "latitude": 3.27199,
    "longitude": -73.087749,
    "provinceVictim": null
  }, {
    "id": "52",
    "name": "Nariño",
    "habitanRate": 1809301,
    "latitude": 1.289151,
    "longitude": -77.35794,
    "provinceVictim": null
  }, {
    "id": "54",
    "name": "Norte de Santander",
    "habitanRate": 1391366,
    "latitude": 7.946283,
    "longitude": -72.898807,
    "provinceVictim": null
  }, {
    "id": "86",
    "name": "Putumayo",
    "habitanRate": 358896,
    "latitude": 0.435951,
    "longitude": -75.52767,
    "provinceVictim": null
  }, {
    "id": "63",
    "name": "Quindio",
    "habitanRate": 574960,
    "latitude": 4.461019,
    "longitude": -75.667356,
    "provinceVictim": null
  }, {
    "id": "66",
    "name": "Risaralda",
    "habitanRate": 967780,
    "latitude": 5.315847,
    "longitude": -75.992765,
    "provinceVictim": null
  }, {
    "id": "68",
    "name": "Santander",
    "habitanRate": 2090854,
    "latitude": 6.643708,
    "longitude": -73.653621,
    "provinceVictim": null
  }, {
    "id": "70",
    "name": "Sucre",
    "habitanRate": 877024,
    "latitude": 8.813977,
    "longitude": -74.723283,
    "provinceVictim": null
  }, {
    "id": "73",
    "name": "Tolima",
    "habitanRate": 1419957,
    "latitude": 4.092517,
    "longitude": -75.154538,
    "provinceVictim": null
  }, {
    "id": "76",
    "name": "Valle del Cauca",
    "habitanRate": 4755760,
    "latitude": 3.800889,
    "longitude": -76.641271,
    "provinceVictim": null
  }, {
    "id": "97",
    "name": "Vaupés",
    "habitanRate": 44928,
    "latitude": 0.855356,
    "longitude": -70.811995,
    "provinceVictim": null
  }, {
    "id": "99",
    "name": "Vichada",
    "habitanRate": 77276,
    "latitude": 4.423445,
    "longitude": -69.287754,
    "provinceVictim": null
  }]
}
